window.addEventListener('load', function () {
  const isHomepage = document.body.classList.contains('template-index');
  if (!isHomepage) return;

  initParticles();
  initCursor();
  initScrollReveal();
  initWatcherBadge();
  initGlitchTitles();
  initTapGlow();
  initAnnouncementScroll();

  function initParticles() {
    if (document.getElementById('ff-canvas')) return;
    const canvas = document.createElement('canvas');
    canvas.id = 'ff-canvas';
    canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;z-index:0;pointer-events:none;';
    document.body.appendChild(canvas);
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    const particles = [];
    for (let i = 0; i < 60; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 1.5 + 0.5,
        dx: (Math.random() - 0.5) * 0.4,
        dy: (Math.random() - 0.5) * 0.4,
        o: Math.random() * 0.5 + 0.1
      });
    }
    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(124,58,237,' + p.o + ')';
        ctx.fill();
        p.x += p.dx;
        p.y += p.dy;
        if (p.x < 0 || p.x > canvas.width) p.dx *= -1;
        if (p.y < 0 || p.y > canvas.height) p.dy *= -1;
      });
      requestAnimationFrame(draw);
    }
    draw();
  }

  function initCursor() {
    const cursor = document.createElement('div');
    cursor.className = 'ff-cursor';
    cursor.style.pointerEvents = 'none';
    document.body.appendChild(cursor);
    document.addEventListener('mousemove', function (e) {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
    });
  }

  function initScrollReveal() {
    const els = document.querySelectorAll('.ff-reveal');
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.1 });
    els.forEach(el => obs.observe(el));
  }

  function initWatcherBadge() {
    const badge = document.querySelector('.ff-watcher-count');
    if (!badge) return;
    const base = Math.floor(Math.random() * 15) + 15;
    badge.textContent = base;
    setInterval(() => {
      const delta = Math.random() > 0.5 ? 1 : -1;
      const current = parseInt(badge.textContent);
      badge.textContent = Math.max(10, current + delta);
    }, 4000);
  }

  function initGlitchTitles() {
    document.querySelectorAll('.ff-glitch').forEach(el => {
      el.setAttribute('data-text', el.textContent);
    });
  }

  function initTapGlow() {
    document.querySelectorAll('.ff-why-card').forEach(card => {
      card.addEventListener('touchstart', function () {
        this.style.borderColor = '#7C3AED';
      }, { passive: true });
      card.addEventListener('touchend', function () {
        this.style.borderColor = '';
      }, { passive: true });
    });
  }

  function initAnnouncementScroll() {}
});
